<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
  created() {
    console.log("HREF", window.location.href);
    console.log("URL", window.location.pathname);

    if (window.location.pathname == "/wp-admin/admin.php") {
      this.$router.push("/adminsec");
    }
  },
};
</script>
